import { render, staticRenderFns } from "./CreateEvaluation.vue?vue&type=template&id=497d3819&scoped=true"
import script from "./CreateEvaluation.vue?vue&type=script&lang=js"
export * from "./CreateEvaluation.vue?vue&type=script&lang=js"
import style0 from "./CreateEvaluation.vue?vue&type=style&index=0&id=497d3819&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497d3819",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('497d3819')) {
      api.createRecord('497d3819', component.options)
    } else {
      api.reload('497d3819', component.options)
    }
    module.hot.accept("./CreateEvaluation.vue?vue&type=template&id=497d3819&scoped=true", function () {
      api.rerender('497d3819', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/mentalHealth/MindEvaluation/components/CreateEvaluation.vue"
export default component.exports